export const PRODUCTS_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Indústria e Comércio",
   "url": "https://everest.ind.br/pt",
   "logo": "https://everest.ind.br/assets/images/logo-slogan.png",
   "image": "https://everest.ind.br/assets/images/logo-slogan.png"
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest: Qualidade em Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR"
  },
  {
   "@type": "CollectionPage",
   "@id": "https://everest.ind.br/pt/purificadores#webpage",
   "url": "https://everest.ind.br/pt/purificadores",
   "name": "Purificadores de Água Everest",
   "description": "Conheça a linha completa de purificadores de água Everest com alta qualidade, eficiência e design moderno.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/purificadores#breadcrumb"
   },
   "mainEntity": {
    "@type": "ItemList",
    "itemListOrder": "https://schema.org/ItemListOrderAscending",
    "itemListElement": [
     {
      "@type": "ListItem",
      "position": 1,
      "item": {
       "@type": "Product",
       "@id": "https://everest.ind.br/pt/produto/everest-star#product",
       "name": "Purificador Everest Star",
       "image": "https://assets.everest.ind.br/images/Star_Frontal_Branco.original.png",
       "url": "https://everest.ind.br/pt/produto/everest-star",
       "brand": {
        "@type": "Brand",
        "name": "Everest"
       },
       "offers": {
        "@type": "Offer",
        "price": "1336.34",
        "priceCurrency": "BRL",
        "availability": "https://schema.org/InStock",
        "url": "https://everest.ind.br/pt/produto/everest-star",
        "priceValidUntil": "2026-12-31"
       }
      }
     },
     {
      "@type": "ListItem",
      "position": 2,
      "item": {
       "@type": "Product",
       "@id": "https://everest.ind.br/pt/produto/everest-slim#product",
       "name": "Purificador Everest Slim",
       "image": "https://assets.everest.ind.br/images/Slim_frontal_Preto_Kdj6vRZ.original.png",
       "url": "https://everest.ind.br/pt/produto/everest-slim",
       "brand": {
        "@type": "Brand",
        "name": "Everest"
       },
       "offers": {
        "@type": "Offer",
        "price": "1291.65",
        "priceCurrency": "BRL",
        "availability": "https://schema.org/InStock",
        "url": "https://everest.ind.br/pt/produto/everest-slim",
        "priceValidUntil": "2026-12-31"
       }
      }
     },
     {
      "@type": "ListItem",
      "position": 3,
      "item": {
       "@type": "Product",
       "@id": "https://everest.ind.br/pt/produto/everest-fit#product",
       "name": "Purificador Everest Fit",
       "image": "https://assets.everest.ind.br/images/Fit_frontal_Prata_1.original.png",
       "url": "https://everest.ind.br/pt/produto/everest-fit",
       "brand": {
        "@type": "Brand",
        "name": "Everest"
       },
       "offers": {
        "@type": "Offer",
        "price": "1336.34",
        "priceCurrency": "BRL",
        "availability": "https://schema.org/InStock",
        "url": "https://everest.ind.br/pt/produto/everest-fit",
        "priceValidUntil": "2026-12-31"
       }
      }
     },
     {
      "@type": "ListItem",
      "position": 4,
      "item": {
       "@type": "Product",
       "@id": "https://everest.ind.br/pt/produto/everest-baby#product",
       "name": "Purificador Everest Baby",
       "image": "https://assets.everest.ind.br/images/Baby_frontal_Cereja.original.png",
       "url": "https://everest.ind.br/pt/produto/everest-baby",
       "brand": {
        "@type": "Brand",
        "name": "Everest"
       },
       "offers": {
        "@type": "Offer",
        "price": "445.26",
        "priceCurrency": "BRL",
        "availability": "https://schema.org/InStock",
        "url": "https://everest.ind.br/pt/produto/everest-baby",
        "priceValidUntil": "2026-12-31"
       }
      }
     },
     {
      "@type": "ListItem",
      "position": 5,
      "item": {
       "@type": "Product",
       "@id": "https://everest.ind.br/pt/produto/everest-plus#product",
       "name": "Purificador Everest Plus",
       "image": "https://assets.everest.ind.br/images/Plus_frontal_Branco.original.png",
       "url": "https://everest.ind.br/pt/produto/everest-plus",
       "brand": {
        "@type": "Brand",
        "name": "Everest"
       },
       "offers": {
        "@type": "Offer",
        "price": "1380.00",
        "priceCurrency": "BRL",
        "availability": "https://schema.org/InStock",
        "url": "https://everest.ind.br/pt/produto/everest-plus",
        "priceValidUntil": "2026-12-31"
       }
      }
     }
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/purificadores#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Início",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Purificadores",
     "item": "https://everest.ind.br/pt/purificadores"
    }
   ]
  }
 ]
}
